import { createClient } from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

export const client = createClient({
  projectId: "hdr5v921", // your actual Sanity project ID
  dataset: "production",
  apiVersion: "2025-10-20", // today's or recent date
  useCdn: true,
});

const builder = imageUrlBuilder(client);
export const urlFor = (source) => builder.image(source);
export const getFileUrl = (fileRef) => {
  if (!fileRef || !fileRef.asset || !fileRef.asset._ref) return "";

  const ref = fileRef.asset._ref;
  // ref = "file-5e996e6d72572db7b10664177d0f189a7dad3af9-mp4"

  const [, id, extension] = ref.split("-");

  const projectId = client.config().projectId;
  const dataset = client.config().dataset;

  return `https://cdn.sanity.io/files/${projectId}/${dataset}/${id}.${extension}`;
};
